import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export interface MarkSheetSubmission {
  submittedBy: { id: number; displayName: string } | null;
  submittedAt: string | null;
  markCount: number;
}

export const AcademicMarksheetApi = createApi({
  reducerPath: 'AcademicMarksheetApi',
  baseQuery,
  tagTypes: ['marksheet', 'marksheet-history'],
  endpoints: builder => ({
    getMarkSheet: builder.query<any, { columnId: string }>({
      query: ({ columnId }) => `/academics/assignments/${columnId}/mark-sheet`,
      providesTags: ['marksheet'],
    }),

    submitMarkSheet: builder.mutation<any, { columnId: string }>({
      query: ({ columnId }) => ({
        url: `/academics/assignments/${columnId}/mark-sheet/submit`,
        method: 'POST',
      }),
      invalidatesTags: ['marksheet'],
    }),

    unlockMarkSheet: builder.mutation<any, { columnId: string; reason: string }>({
      query: ({ columnId, reason }) => ({
        url: `/academics/assignments/${columnId}/mark-sheet/unlock`,
        method: 'POST',
        body: { reason },
      }),
      invalidatesTags: ['marksheet'],
    }),

    getMarkSheetHistory: builder.query<any, { columnId: string }>({
      query: ({ columnId }) =>
        `/academics/assignments/${columnId}/mark-sheet/history`,
      providesTags: ['marksheet-history'],
    }),

    recordMark: builder.mutation<
      any,
      {
        columnId: string;
        data: {
          score: number;
          studentId: number;
        };
      }
    >({
      query: ({ columnId, data }) => ({
        url: `/academics/assignments/${columnId}/mark-sheet`,
        method: 'POST',
        body: data,
      }),
      // Server-side (RecordMarkService) upserts on (student, assignment) and
      // is a no-op for the audit trail when the resubmitted score is
      // unchanged, so this endpoint is safe to auto-retry on a lost response.
      extraOptions: { enableMutationRetry: true },
      invalidatesTags: ['marksheet', 'marksheet-history', 'assignments' as any],
    }),
  }),
});

export const {
  useGetMarkSheetQuery,
  useGetMarkSheetHistoryQuery,
  useRecordMarkMutation,
  useSubmitMarkSheetMutation,
  useUnlockMarkSheetMutation,
} = AcademicMarksheetApi;
